import React, { InputHTMLAttributes } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { FormWrapper, Label, Input, Error, TextArea } from './styles';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TArgs = { [argName: string]: any };
export interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  errors?: FieldError;
  register: UseFormRegisterReturn;
  mask?: string;
  rows?: number;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  errors,
  register,
  mask,
  rows,
  ...props
}) => {
  return (
    <FormWrapper>
      <Label htmlFor={name}>{label}</Label>
      {mask ? (
        <InputMask id={name} {...props} {...register} mask={mask} className="inputPhone" />
      ) : rows ? (
        <TextArea id={name} {...register} placeholder="Mensagem" rows={rows} />
      ) : (
        <Input id={name} {...props} {...register} />
      )}
      <Error>{errors?.message}</Error>
    </FormWrapper>
  );
};

export default FormInput;
